import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../styles/ReviewCard.css'; // Pensez à créer ce fichier pour les styles
import StarRating from '../StarRating'; // Vérifiez le chemin d'importation


const ReviewCard = ({ review }) => {
    const [expanded, setExpanded] = useState(false);

    // Le titre est soit l'identifiant s'il existe, sinon les 4 premiers mots du commentaire
    const title = review.identifier && review.identifier.trim().length > 0
        ? review.identifier
        : review.reviewText.split(' ').slice(0, 4).join(' ') + '...';

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    return (
        <motion.div
            className="review-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
        >
            <h3 className="review-title">{title}</h3>

            <div className="review-body">
                <p className={`review-text ${expanded ? 'expanded' : 'collapsed'}`}>
                    {review.reviewText}
                </p>
                {/* Afficher le bouton "Voir plus" si le texte est long */}
                {review.reviewText.split(' ').length > 20 && (
                    <button className="toggle-button" onClick={toggleExpanded}>
                        {expanded ? 'Voir moins' : 'Voir plus'}
                    </button>
                )}
            </div>

            <div className="review-meta">

                {review.reviewerType && (
                    <span className="review-type">
            Type:{" "}
                        {review.reviewerType === 'Presse'
                            ? 'Presse'
                            : review.reviewerType === 'Cinema'
                                ? 'Milieu du cinéma'
                                : 'Cinephile'}
          </span>
                )}
            </div>
            <StarRating initialRating={review.rating} readOnly={true} />

            <div className="review-date">
                {new Date(review.createdAt).toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'long',
                    hour: '2-digit',
                    minute: '2-digit'
                })}
            </div>
        </motion.div>
    );
};

export default ReviewCard;

/*
<span className="review-age"> {review.ageGroup} </span>

<span className="review-gender">
          {review.gender === 'male' ? 'Homme' : 'Femme'}
        </span>

                <span className="review-source">
          {Array.isArray(review.heardFrom)
              ? review.heardFrom.join(', ')
              : review.heardFrom}
        </span>
*/

































































